<script setup lang="ts">
import {PropType, ref, watch} from "vue";
import {odsIcon} from "../../components/odsIcon";
import {odsPill, PillTheme} from "../../components/odsPill";
import {odsFieldMessage} from "../../components/odsFieldMessage";

const emit = defineEmits([
  'change',
])

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  defaultValue: {
    type: Boolean,
    default: false,
  },
  message: {
    type: String,
    default: '',
  },
  messageTheme: {
    type: String as PropType<typeof PillTheme[keyof typeof PillTheme]>,
    default: PillTheme.Default,
  },
  validators: {
    type: Array as PropType<{ label: string; theme: (value: boolean) => PillTheme; }[]>,
    default: [],
  },
});

const checked = ref(props.defaultValue);

function toggle() {
  if (props.disabled)
    return;

  checked.value = !checked.value;
  emit('change', checked.value);
}

watch(() => props.defaultValue, (newVal, oldVal) => {
  if(newVal != oldVal){
    checked.value = newVal
  }
})

</script>

<template>
  <div class="ods-checkbox">
    <div class="checkbox-container">
      <div class="checkbox-wrapper"
           :class="[{checked, disabled}]"
           @click="toggle"
      >
        <odsIcon
            v-if="checked"
            :name="'check'"
        />
        <input
            :disabled="disabled"
            v-model="checked"
            :id="id"
            type="checkbox"
            @change.stop="emit('change', checked)"
        >
      </div>
      <slot>
        <label
            :for="id"
            v-html="label"
        />
      </slot>
    </div>
    <div v-if="validators.length > 0" class="conditions">
      <odsPill
          v-for="(validator, index) of validators"
          :key="index"
          :theme="validator.theme(checked)"
          :label="validator.label"
      />
    </div>
    <odsFieldMessage
        :message="message"
        :message-theme="messageTheme"
    />
  </div>
</template>

<style lang="scss" src="./odsCheckbox.scss"/>